export const download = <i className="fa-solid fa-cloud-arrow-down"></i>;
export const flame = <i className="fa-solid fa-fire-flame-curved"></i>;
export const medal = <i className="fa-solid fa-medal"></i>;
export const brief = <i className="fa-solid fa-briefcase"></i>;
export const mug = <i className="fa-solid fa-mug-hot"></i>;
export const git = <i className="fa-brands fa-github"></i>;
export const eye = <i className="fa-solid fa-eye"></i>;
export const arrow = <i className="fa-solid fa-arrow-right"></i>;
export const user = <i className="fa-solid fa-user"></i>;
export const education = <i className="fa-solid fa-user-graduate"></i>;
export const design = <i className="fa-solid fa-bezier-curve"></i>;
export const desktop = <i className="fa-solid fa-desktop"></i>;
export const code = <i className="fa-solid fa-code"></i>;
export const jew = <i className="fa-solid fa-star-of-david"></i>;
export const smile = <i className="fa-regular fa-face-smile"></i>;
export const more = <i className="fa-solid fa-angles-right"></i>;
export const read = <i className="fa-solid fa-book-open-reader"></i>;
export const atlas = <i className="fa-solid fa-book-atlas"></i>;
export const school = <i className="fa-sharp fa-solid fa-chalkboard-user"></i>;
export const reads = <i className="fa-brands fa-readme"></i>;
export const reform = <i className="fa-solid fa-list-check"></i>;
export const link = <i className="fa-solid fa-link"></i>;
